<!--企业认证-->
<template>
  <div class="enterprise-certification-container">
    <header-index/>
    <div class="enterprise-certification-content">
      <div class="enterprise-certification-top">
        <div class="bigger-li"><span>身份认证</span></div>
        <div class="small-li"><span>身份认证是对用户身份的确认，认证通过后，用户将拥有更多权益</span></div>
      </div>
      <div class="enterprise-certification-main">
        <el-container>
          <el-aside width="180px" style="background: #F2F2F2;height: 25vh;">
            <el-menu :default-active="activeIndex" class="el-menu-vertical-demo" @select="handleSelect" background-color="#F2F2F2" active-text-color="#FE273B">
              <el-menu-item v-for="bar of navigationBar" :index="bar.href" :disabled="bar.clickStatus==1 ? true : false">
                <el-popover placement="left" width="200" trigger="hover" content="认证信息审核中，请耐心等待！" v-if="bar.clickStatus==1">
                  <span slot="reference">{{ bar.title }}
                    <i class="under-certification" v-if="bar.certificationStatus==2">认证中</i>
                    <i class="success-certification" v-if="bar.certificationStatus==1">认证成功</i>
                  </span>
                </el-popover>
                <span v-else>{{ bar.title }}</span>
              </el-menu-item>
            </el-menu>
          </el-aside>
          <el-main>
            <personal-certification v-if="activeIndex=='/officialCloud/personalCertification'" :disabled="disabled"/>
            <operation-certification v-if="activeIndex=='/officialCloud/operationCertification'" :disabled="disabled"/>
            <agency-certification v-if="activeIndex=='/officialCloud/agencyCertification'" :disabled="disabled"/>
            <media-authentication v-if="activeIndex=='/officialCloud/mediaAuthentication'" :disabled="disabled"/>
          </el-main>
        </el-container>
      </div>
    </div>
    <home_footer/>
    <Hang/>
  </div>
</template>
<script>
import HeaderIndex from "@/components/header/headerIndex";
import Home_footer from "@/components/footer/home_footer";
import Hang from "@/components/Hang/Hangs";
import PersonalCertification from "@/views/officialCloud/personalCertification";
import OperationCertification from "@/views/officialCloud/operationCertification";
import AgencyCertification from "@/views/officialCloud/agencyCertification";
import MediaAuthentication from "@/views/officialCloud/mediaAuthentication";
import {identityAuthenticationList} from '@/api/systemSetting'
export default {
  name: "enterpriseCertification",
  components: {
    MediaAuthentication,
    AgencyCertification, OperationCertification, PersonalCertification, Hang, Home_footer, HeaderIndex},
  data() {
    return {
      min_height: document.documentElement.clientHeight - 275,
      activeIndex:'/officialCloud/personalCertification',
      navigationBar:[],
      userInfo:{},
      disabled:false,
    }
  },
  methods:{
    handleSelect(key) {
      this.activeIndex = key;
    },
    getIdentityAuthenticationList(){
      identityAuthenticationList({userId:this.userInfo.cid,request:'form'}).then(res=>{
        if (res.code==200){
          for (let list of res.content.list){
            if (list.clickStatus==1){
              this.disabled=true;
            }else{
              this.disabled=false;
            }
            if (list.title=='个人认证'){
              list.href='/officialCloud/personalCertification';
              this.navigationBar.push(list);
            }else if (list.title=='企业认证'){
              list.href='/officialCloud/operationCertification';
              this.navigationBar.push(list);
            }else if (list.title=='机构认证'){
              list.href='/officialCloud/agencyCertification';
              this.navigationBar.push(list);
            }else if (list.title=='媒体认证'){
              list.href='/officialCloud/mediaAuthentication';
              this.navigationBar.push(list);
            }
          }
        }
      })
    }
  },
  mounted() {
    this.getIdentityAuthenticationList();
  },
  beforeMount() {
    this.userInfo=sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')) : {};
  }
}
</script>
<style scoped>
.enterprise-certification-container >>> .enterprise-certification-content .enterprise-certification-main .el-menu{
  border-right: none;
}
.enterprise-certification-container >>> .enterprise-certification-content .enterprise-certification-main .el-card__body,
.enterprise-certification-container >>> .enterprise-certification-content .enterprise-certification-main .el-main {
  padding: 0 0px 0px 40px;
}
.enterprise-certification-container >>> .enterprise-certification-content .enterprise-certification-main .el-menu-item.is-disabled {
  opacity: 1;
}
</style>
<style scoped lang="scss">
.enterprise-certification-container {
  background: #ffffff;
  .enterprise-certification-content {
    padding: 0px 18%;
    min-width: 76rem;
    background: #ffffff;
    .enterprise-certification-top {
      background: url("~@/assets/img/enterprise/authentication.png") no-repeat;
      height: 330px;
      width: 100vw;
      background-size: 100% 100%;
      text-align: center;
      display: table-cell;
      vertical-align: middle;
      align-items: center;
      cursor: pointer;
      .bigger-li {
        font-size: 48px;
        font-family: 'SourceHanSansCN';
        font-weight: 400;
        color: #FFFFFF;
      }
      .small-li {
        color: #FFFFFF;
      }
    }
    .enterprise-certification-main{
      padding: 20px 0px;
      .under-certification{
        color: #FE273B;
        background-color: #FFE7E9;
        font-style: normal;
        font-size: 14px;
        margin-left: 10px;
        padding: 2px 6px;
        border: 1px solid #FE273B;
        border-radius: 6px;
      }
      .success-certification{
        color: #03AE02;
        background-color: #f0f9eb;
        font-style: normal;
        font-size: 14px;
        margin-left: 10px;
        padding: 2px 6px;
        border: 1px solid #03AE02;
        border-radius: 6px;
      }
    }
  }
}
</style>